//THEME
import defaults from "./custom/defaults.js";
import navbar from "./custom/navbar.js";
import footer from "./custom/footer.js";
import parallax from "./custom/parallax.js";
import anchorNav from "./custom/anchorNav.js";
import avatar from "./custom/avatar.js";
import megaMenu from "./custom/megaMenu.js";
import photo_gallery from "./custom/photo-gallery.js";
import hero_video from "./custom/hero-video.js";
import faqNav from "./custom/faqNav.js";
// NB : flipdown + mission-video sont volontairement HORS de ce bundle.
// Ils vivent dans le bundle autonome "mission" (theme/js/mission-entry.js →
// dist/mission.js), injecté inline dans le <head> sur la home pour s'exécuter
// avant app.js (perf : le countdown ne dépend pas de jQuery). Les réimporter
// ici provoquerait une double initialisation.
//EXTRAS
//import vhb from './custom/vhb.js';
//import cards from './custom/cards.js';
//import progressBar from './custom/progressBar.js';
//import annimate from './custom/annimate.js';

//VueJS
//import footer from './custom/vue-scripts.js';
